import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";

export const useImportPlanOptionsViewModel = ({
  stateManager,
  planDetails,
  setPlanDetails,
}) => {
  const [selectedOptionId, setSelectedOptionId] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [openRemoveOptionModal, setOpenRemoveOptionModal] = useState(false);

  const handleOptionClick = (option) => {
    setSelectedOptionId(option.optionId);
  };

  const handleRemoveOption = () => {
    const updatedPlanDetails = { ...planDetails };

    updatedPlanDetails.options = updatedPlanDetails.options.map((option) =>
      option.optionId === selectedOption.optionId
        ? { ...option, optionRemoved: true, reviewed: true }
        : option
    );

    stateManager.run(async () => {
      const response = await homeService.plans.importPlanOptionReviewed({
        data: {
          optionId: selectedOption.optionId,
          optionRemoved: true,
          reviewed: true,
        },
        id: planDetails.planId,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setPlanDetails(updatedPlanDetails);
        setOpenRemoveOptionModal(false);
      }
    });
  };

  const handleReactivateOption = (optionId) => {
    const updatedPlanDetails = { ...planDetails };

    updatedPlanDetails.options = updatedPlanDetails.options.map((option) =>
      option.optionId === optionId
        ? { ...option, optionRemoved: false, reviewed: false }
        : option
    );

    stateManager.run(async () => {
      const response = await homeService.plans.importPlanOptionReviewed({
        data: {
          optionId,
          optionRemoved: false,
          reviewed: false,
        },
        id: planDetails.planId,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setPlanDetails(updatedPlanDetails);
      }
    });
  };

  const handleReviewed = (optionId, reviewed) => {
    const updatedPlanDetails = { ...planDetails };

    updatedPlanDetails.options = updatedPlanDetails.options.map((option) =>
      option.optionId === optionId ? { ...option, reviewed } : option
    );

    stateManager.run(async () => {
      const response = await homeService.plans.importPlanOptionReviewed({
        data: {
          optionId,
          optionRemoved: false,
          reviewed,
        },
        id: planDetails.planId,
      });
      if (response.status === HTTP_STATUSES.OK) {
        setPlanDetails(updatedPlanDetails);
      }
    });
  };

  const handleOpenRemoveOptionModal = (option) => {
    setSelectedOption(option);
    setOpenRemoveOptionModal(true);
  };

  const handleRemoveOrReactivateOption = (option) => {
    if (option.optionRemoved) {
      handleReactivateOption(option.optionId);
    } else {
      handleOpenRemoveOptionModal(option);
    }
  };

  return {
    selectedOptionId,
    setSelectedOptionId,
    handleOptionClick,
    selectedOption,
    setSelectedOption,
    openRemoveOptionModal,
    setOpenRemoveOptionModal,
    handleRemoveOption,
    handleReviewed,
    handleRemoveOrReactivateOption,
  };
};
